module.exports = __webpack_public_path__ + "static/img/iconfont.9db0279d.svg";